<div class="caremoni-textbox input-style" [ngStyle]="inputParams.inputStyle">
    <div class="caremoni-textbox-content" 
 
      *ngIf="!inputParams.hidden">
        <input class="caremoni-input" type={{inputType}} placeholder="{{inputParams.placeholder}}" id={{inputId}}
            [attr.dpad]="dpad"
            [style.--scale-dpad]="scaledpad"
            [attr.x-dpad]="xdpad" 
            [attr.y-dpad]="ydpad" 
            [attr.tab-dpad]="tabdpad"
            [attr.x-tab-dpad]="xtabdpad" 
            [attr.y-tab-dpad]="ytabdpad"
            [tabIndex]="inputParams.tabindex || 1"
            [disabled]="inputParams.disabled" [readonly]="inputParams.readonly" [ngModel]="inputValue"
            [maxlength]="inputParams.maxLength ? inputParams.maxLength : null"
            [minlength]="inputParams.minLength ? inputParams.minLength : null"
            [ngClass]="{
                'input-readonly': inputParams.readonly && inputParams.borderFill,
                'caremoni-input-err': !(inputParams.readonly && inputParams.borderFill) && inputParams.validate && (showValidateErr || inputParams.isValidate),
                'input-padding': !(inputParams.readonly && inputParams.borderFill) && !(inputParams.validate && (showValidateErr || inputParams.isValidate)) && inputEdit,
                'input-text-center': textCenter,
                'border-red-err': inputParams.borderRed
            }"
            (keydown)="onKeyDowns($event)" (click)="onClicks($event)" (focus)="onFocusIn($event)"
            (focusout)="onFocusOutInput($event)" (input)="onInputData($event)" (keyup)="onKeyUps($event)"
            (tv-keyboard-done)="onKeyboardDoneEvent($event)" />
        <span *ngIf="canClear && !empty(inputValue)" class="item-delete" (click)="clearText()">
            <i class="pi pi-times"></i>
        </span>
    </div>
    <label *ngIf="(inputParams.validate && showValidateErr) || (inputParams.validate && inputParams.isValidate)"
        class="caremoni-validate-err">{{inputParams.validateError}}</label>
</div>